import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { Button } from './ui/button';
import { useTranslation } from 'react-i18next';

export default function BackButton() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const handleBack = () => {
    // Check if there's history to go back to
    if (window.history.length > 1) {
      navigate(-1);
    } else {
      // If no history, go to home
      navigate('/');
    }
  };

  return (
    <Button
      onClick={handleBack}
      variant="ghost"
      className="fixed top-4 left-4 z-50 bg-slate-800/90 hover:bg-slate-700 text-white backdrop-blur-sm shadow-lg border border-slate-600"
      size="lg"
    >
      <ArrowLeft className="w-5 h-5 mr-2" />
      {t('common.back')}
    </Button>
  );
}
